import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    tTestPerformed: false,
    tTestType: "",
    tTestconfidenceInterval: "",
    tTestProducts: [],
    tTestCoreDataId: null,
    tTestCheckedDataTypeForTest: "",
    tTestDataType: "",
    tTestAnalysisType: "", // payload key top bottom mean
    testAnalysisType: "", // key on which test is performed
    testJarAnalysisType: "", // key for jar analysis
    tTestBoxAnalysis: {},
    tTestSelectedProducts: {},
    tTestSelections: {},
    tTestFaLegends: [],
};

export const tTestStore = createSlice({
    name: "tTestStore",
    initialState,
    reducers: {
        loadTestAnalysisType: (state, action) => {
            state.testAnalysisType = action.payload;
        },
        loadTTestJarAnalysisType: (state, action) => {
            state.testJarAnalysisType = action.payload;
        },
        loadTTestPerformed: (state, action) => {
            state.tTestPerformed = action.payload;
        },
        loadTTestType: (state, action) => {
            state.tTestType = action.payload;
        },
        loadTTestConfidenceInterval: (state, action) => {
            state.tTestconfidenceInterval = action.payload;
        },
        loadTTestProducts: (state, action) => {
            state.tTestProducts = action.payload;
        },
        loadTTestCoreDataId: (state, action) => {
            state.tTestCoreDataId = action.payload;
        },
        loadTTestCheckedDataTypeForTest: (state, action) => {
            state.tTestCheckedDataTypeForTest = action.payload;
        },
        loadTTestDataType: (state, action) => {
            state.tTestDataType = action.payload;
        },
        loadTTestAnalysisType: (state, action) => {
            state.tTestAnalysisType = action.payload;
        },
        loadTTestBoxAnalysis: (state, action) => {
            state.tTestBoxAnalysis = action.payload;
        },
        loadTTestSelectedProducts: (state, action) => {
            state.tTestSelectedProducts = action.payload;
        },
        loadTTestSelections: (state, action) => {
            state.tTestSelections = action.payload;
        },
        loadTTestFaLegends: (state, action) => {
            state.tTestFaLegends = action.payload;
        },
        resetTTestStore: () => initialState,
    },
});

export const {
    loadTestAnalysisType,
    loadTTestJarAnalysisType,
    loadTTestPerformed,
    loadTTestType,
    loadTTestConfidenceInterval,
    loadTTestProducts,
    loadTTestCoreDataId,
    loadTTestCheckedDataTypeForTest,
    loadTTestDataType,
    loadTTestAnalysisType,
    resetTTestStore,
    loadTTestBoxAnalysis,
    loadTTestSelections,
    loadTTestFaLegends,
    loadTTestSelectedProducts,
} = tTestStore.actions;
export default tTestStore.reducer;
